export const navItems = [
  { to: "/", key: "home" },
  { to: "/menu", key: "menu" },
  { to: "/catering", key: "catering" },
  { to: "/gallery", key: "gallery" },
  { to: "/our-story", key: "story" },
  { to: "/visit-us", key: "visit" },
];
